import { Stack, Box, Typography, List, ListItem } from "@mui/material";
import "../../styles/ListingPageFilter.css";
import { definitions, userResponsibilities, deliverResponsibilities, prohibitedItem, liabilityLimitations} from "../../data/PrivacyPolicy";

const TermsOfUse = () => {
    return (
        <Stack className="policy-box">
            <Box>
                <Typography variant='body2' className="sub-text-style common-font-size">A2B Deliver Terms of Use</Typography>
            </Box>
            <Box className="common-margin-top">
                <Typography variant='h6' className="header-weight">Welcome to A2B Deliver!</Typography>
                <Typography variant='body2' className="sub-text-style common-font-size common-margin-top">These Terms of Use ("Terms") govern your access to and use of the A2B Deliver delivery services, website, and mobile applications (collectively, the "Services"). By using the Services, you agree to be bound by these Terms. If you do not agree to these Terms, please do not use the Services.</Typography>
            </Box>
            <Box className="common-margin-top">
                <Typography variant='h6' className="header-weight">1. Definitions</Typography>
                <List className="disc-styles">
                    {definitions.map((data, idx) => (
                        <ListItem key={idx} disablePadding className="sub-header"> 
                            <span className="sub-list-text">{data?.title}</span> <span className="common-font-size">{data?.content}</span>
                        </ListItem>
                    ))}
                </List>
            </Box>
            <Box className="common-margin-top">
                <Typography variant='h6' className="header-weight">2. User Responsibilities</Typography>
                <List className="disc-styles">
                    {userResponsibilities.map((data, idx) => (
                        <ListItem key={idx} disablePadding className="sub-header"> 
                            <span className="sub-list-text">{data?.title}</span> <span className="common-font-size">{data?.content}</span>
                        </ListItem>
                    ))}
                </List>
            </Box>
            <Box className="common-margin-top">
                <Typography variant='h6' className="header-weight">3. A2B Deliver Responsibilities</Typography>
                <List className="disc-styles">
                    {deliverResponsibilities.map((data, idx) => (
                        <ListItem key={idx} disablePadding className="sub-header"> 
                            <span className="sub-list-text">{data?.title}</span> <span className="common-font-size">{data?.content}</span>
                        </ListItem>
                    ))}
                </List>
            </Box>
            <Box className="common-margin-top">
                <Typography variant='h6' className="header-weight">4. Prohibited Items</Typography>
                <Typography variant='body2' className="sub-text-style common-font-size common-margin-top">The following items are prohibited from being transported through the Services:</Typography>
                <List className="disc-styles">
                    {prohibitedItem.map((data, idx) => (
                        <ListItem key={idx} disablePadding className="sub-header"> 
                            <span className="common-font-size">{data?.title}</span>
                        </ListItem>
                    ))}
                </List>
            </Box>
            <Box className="common-margin-top">
                <Typography variant='h6' className="header-weight">5. Liability Limitations</Typography>
                <List className="disc-styles">
                    {liabilityLimitations.map((data, idx) => (
                        <ListItem key={idx} disablePadding className="sub-header"> 
                            <span className="sub-list-text">{data?.title}</span> <span className="common-font-size">{data?.content}</span>
                        </ListItem>
                    ))}
                </List>
            </Box>
            <Box className="common-margin-top">
                <Typography variant='h6' className="header-weight">6. Termination</Typography>
                <Typography variant='body2' className="sub-text-style common-font-size common-margin-top">A2B Deliver reserves the right to terminate or suspend a user's access to the Services for any reason, including violation of these Terms.</Typography>
            </Box>
            <Box className="common-margin-top">
                <Typography variant='h6' className="header-weight">7. Modifications to Terms</Typography>
                <Typography variant='body2' className="sub-text-style common-font-size common-margin-top">A2B Deliver may modify these Terms at any time. Users will be notified of any changes and continued use of the Services constitutes acceptance of the modified Terms.</Typography>
            </Box>
            <Box className="common-margin-top">
                <Typography variant='h6' className="header-weight">8. Governing Law</Typography>
                <Typography variant='body2' className="sub-text-style common-font-size common-margin-top">These Terms are governed by the laws of [Your Jurisdiction].</Typography>
            </Box>
            <Box className="common-margin-top">
                <Typography variant='h6' className="header-weight">9. Dispute Resolution</Typography>
                <Typography variant='body2' className="sub-text-style common-font-size common-margin-top">Any disputes arising from these Terms will be resolved through [Your Preferred Dispute Resolution Method].</Typography>
                <Typography variant='body2' className="common-font-size common-margin-top" sx={{ marginBottom: '2rem', fontWeight: '700' }}>By using A2B Deliver's Services, you acknowledge that you have read, understood, and agreed to these Terms of Use</Typography>
            </Box>
        </Stack>
    )
}

export default TermsOfUse;